import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

export const fireContentMenuItemClickedAnalytics =
	(
		createAnalyticsEvent: CreateUIAnalyticsEvent,
		actionSubjectId: string,
		options: {
			componentType?: string;
			itemId?: string;
			contentType?: string | null;
			contentId?: string | null;
			contentStatus?: string | null;
			section?: string;
			selectedFilter?: string;
			parentContentType?: string | null;
			parentContentId?: string | null;
			is3pLink?: boolean;
			product?: string;
			eventType?: string;
		},
	) =>
	(): void => {
		const {
			componentType,
			itemId,
			contentType,
			contentId,
			contentStatus,
			section,
			selectedFilter,
			parentContentType,
			parentContentId,
			is3pLink,
			product,
			eventType,
		} = options;

		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId,
				source: 'globalNavigation',
				attributes: {
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					navVersion: '4',
					componentType,
					itemId,
					contentType,
					contentId,
					contentStatus,
					section,
					selectedFilter,
					parentContentType,
					parentContentId,
					is3pLink,
					product,
					eventType,
				},
			},
		}).fire();
	};
